import { render, staticRenderFns } from "./AlertUserSelector.vue?vue&type=template&id=be30cac0&scoped=true"
import script from "./AlertUserSelector.vue?vue&type=script&lang=js"
export * from "./AlertUserSelector.vue?vue&type=script&lang=js"
import style0 from "./AlertUserSelector.vue?vue&type=style&index=0&id=be30cac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be30cac0",
  null
  
)

export default component.exports